import { clientsApi } from '@/features/clients/clientsApi';
import { dealsApi } from '@/features/deals/dealsApi';
import { getDealClientId } from '@/features/deals/helper';
import { getConsentFieldsFromRecords } from './helpers';

// Kept out of helpers.js: clientsApi imports helpers.js, and dealsApi imports clientsApi.

/**
 * Writes a client's consent fields into its cached client and deal rows. The deal list
 * overlays cached deal rows on search results, so it shows the new status while the
 * triggers copy it onto the deals and Typesense catches up.
 */
export const updateConsentCache = (clientId) => async (dispatch, getState) => {
	try {
		const records = await dispatch(
			clientsApi.endpoints.listInformedConsents.initiate(clientId, { forceRefetch: true }),
		).unwrap();
		const fields = getConsentFieldsFromRecords(records);

		dispatch(
			clientsApi.util.updateQueryData('getClientRow', clientId, (draft) => {
				if (draft) Object.assign(draft, fields);
			}),
		);
		dispatch(
			clientsApi.util.updateQueryData('getClientProperties', clientId, (draft) => {
				if (draft?.clientRow) Object.assign(draft.clientRow, fields);
			}),
		);

		const state = getState();
		for (const dealDocId of dealsApi.util.selectCachedArgsForQuery(state, 'getDealRow')) {
			const deal = dealsApi.endpoints.getDealRow.select(dealDocId)(state)?.data;
			if (getDealClientId(deal) !== clientId) continue;

			dispatch(
				dealsApi.util.updateQueryData('getDealRow', dealDocId, (draft) => {
					Object.assign(draft, fields);
				}),
			);
		}
	} catch (error) {
		console.error('[updateConsentCache]', error);
	}
};
